import React from "react";
import { isChunkLoadError, reloadForChunkError } from "./utils/chunkReload";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isReloading: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[UI Crash]", error, info);
    // Stale build after a deploy: reload quietly instead of showing the error screen
    if (isChunkLoadError(error) && reloadForChunkError()) {
      this.setState({ isReloading: true });
    }
  }

  handleReload = () => {
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch {}
   if(navigator?.onLine){
    window.location.reload();
    }
  };

  render() {
    if (this.state.isReloading) {
      return null;
    }

    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, textAlign: "center" }}>
          <h2>Something went wrong</h2>
          <p>Please reload the application.</p>
          <button onClick={this.handleReload}>Reload</button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
